var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"calculation-overview"}},[_c('h6',[_vm._v(_vm._s(_vm.$t('Calculation')))]),_c('calculation-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }